import { getAuth } from 'firebase/auth'
import { getTenantId } from 'auth/FirebaseAuth'
const getToken = async () => {
  const currentUser = getAuth().currentUser
  const tenantId = getTenantId(currentUser)
  console.log('get token', tenantId)
  if (getAuth() && getAuth().currentUser) {
    return { tenantId: tenantId, token: (await getAuth().currentUser.getIdTokenResult()).token }
  } else {
    return null
  }
}

export const createHeader = async () => {
  const { tenantId, token } = await getToken()
  console.log('Create Header: ', tenantId, token)
  return {
    headers: {
      authorization: `Bearer ${token}`, // later change this token to wiToken
      tenantId: tenantId, // later change this tenantId to wiTanentid
      'Content-Type': 'application/json',
    },
    timeout: 0
  }
}
